<template>
  <div>
    <a class="text-gradient hoverable bold" @click="requestDemo">
      Request a guided demo
    </a>
    <alert ref="alert" ok-title="OK" title="Thank you!">
      One of our Specialist will be in touch with you to set up a demo call.
    </alert>
  </div>
</template>

<script>
import Alert from '@/components/Alert.vue'
import service from '@/service'
import urlManager from '@/urlManager'
import showAPIError from '@/utils/showAPIError'

/**
 * This provides the link, click of which triggers a demo request
 */
export default {
  name: 'RequestDemoLink',
  props: ['orgId'],
  components: { Alert },
  data() {
    return {}
  },
  computed: {},
  methods: {
    async requestDemo() {
      try {
        await service.client.post(urlManager.requestDemo(this.orgId))
        this.$refs.alert.show()
      } catch (e) {
        showAPIError(e)
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
